export default "__VITE_ASSET__Yc2t6BETuqA7Sc4ZKLv8pQ__"